import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { getBudgetResetCustomPeriodValidationRules } from './BudgetResetCustomPeriodInput.utils';

export interface BudgetResetCustomPeriodInputProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function BudgetResetCustomPeriodInput({
  name,
  id,
  disabled = false,
}: BudgetResetCustomPeriodInputProps): JSX.Element {
  const { errors, control, watch, formState, trigger } = useFormContext();

  const budgetResetType = watch('budgetResetType');

  useEffect(() => {
    if (formState.dirtyFields.budgetResetPeriod && budgetResetType) {
      trigger(name);
    }
  }, [formState.dirtyFields.budgetResetPeriod, budgetResetType, name, trigger]);

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label={<>&nbsp;</>}
      aria-label="Budget Reset Custom Period"
      placeholder="e.g. 3"
      disabled={disabled}
      rules={getBudgetResetCustomPeriodValidationRules(budgetResetType)}
    />
  );
}
